import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c5119316"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
const _hoisted_4 = {
  class: "bigFont mr16"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft10 mt8"
}, "v1.1.6", -1));
const _hoisted_6 = {
  key: 0,
  class: "account-usage-expire"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_header = _resolveComponent("el-header");
  const _component_WatermarkerView = _resolveComponent("WatermarkerView");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "header"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 7,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10,
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [$data.isFlashPractice ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = $event => $options.goTab(0)),
            class: _normalizeClass($data.tab == 0 ? 'activeTab boldFont ptr' : 'ptr')
          }, "我的练习", 2)) : _createCommentVNode("", true), _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = $event => $options.goTab(2)),
            class: _normalizeClass($data.tab == 2 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "答题历史", 2), _ctx.isClass ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = $event => $options.goTab(1)),
            class: _normalizeClass($data.tab == 1 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "我的课堂", 2)) : _createCommentVNode("", true), _ctx.isClass ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            onClick: _cache[3] || (_cache[3] = $event => $options.goTab(3)),
            class: _normalizeClass($data.tab == 3 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "课后作业", 2)) : _createCommentVNode("", true), _ctx.isClass ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            onClick: _cache[4] || (_cache[4] = $event => $options.goTab(4)),
            class: _normalizeClass($data.tab == 4 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "课堂未做", 2)) : _createCommentVNode("", true), _createElementVNode("span", {
            onClick: _cache[5] || (_cache[5] = $event => $options.goTab(5)),
            class: _normalizeClass($data.tab == 5 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "成绩大盘", 2), _createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = $event => $options.goTab(6)),
            class: _normalizeClass($data.tab == 6 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
          }, "模拟考试", 2)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 7,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [$data.user.userTag == 'ADMIN' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_button, {
            style: {
              "background-color": "#E5F1FE",
              "border": "none",
              "color": "#3269FF"
            },
            onClick: _cache[7] || (_cache[7] = $event => _ctx.$router.push('/'))
          }, {
            default: _withCtx(() => [_createTextVNode("学生视角 ")]),
            _: 1
          }), _createVNode(_component_el_button, {
            style: {
              "background-color": "#E5F1FE",
              "border": "none",
              "color": "#999999"
            },
            onClick: _cache[8] || (_cache[8] = $event => _ctx.$router.push('/m')),
            class: "ml16 mr16"
          }, {
            default: _withCtx(() => [_createTextVNode("管理员视角 ")]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, "hello," + _toDisplayString($data.user.nickName), 1), _createVNode(_component_el_popover, {
            trigger: "click"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                style: {
                  "width": "100%"
                },
                onClick: $options.logout
              }, {
                default: _withCtx(() => [_createTextVNode("退出登录")]),
                _: 1
              }, 8, ["onClick"]), _hoisted_5]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), $data.tab == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "刷机过期时间：" + _toDisplayString($data.user.accountUsageExpire), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "container"
    }, {
      default: _withCtx(() => [_createVNode(_component_WatermarkerView), _createVNode(_component_el_main, {
        class: "main-view"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}